import { format } from "date-fns";
import ko from "date-fns/locale/ko";
import { enUS } from "date-fns/locale";

export const truncateSvgTxt = (txt: string = "", maxLen: number) => {
  if (!txt || txt.length === 0) return "";
  return txt.length > maxLen ? txt.slice(0, maxLen) + "..." : txt;
};

// 예: utils/string.ts

/**
 * 문자열 길이가 maxLength를 넘으면
 * 가운데를 "..."로 대체하면서 앞/뒤를 남기는 함수
 */
export function middleTruncate(str: string, maxLength: number) {
  if (str.length <= maxLength) return str;
  if (maxLength <= 3) {
    // maxLength가 너무 짧으면 그냥 ...만 반환 (또는 잘라서 ...)
    return ".".repeat(Math.min(3, maxLength));
  }

  const remain = maxLength - 3; // "..." 제외하고 남겨둘 글자 수
  const frontLen = Math.ceil(remain / 2);
  const backLen = Math.floor(remain / 2);

  const front = str.slice(0, frontLen);
  const back = str.slice(str.length - backLen);

  return `${front}...${back}`;
}

export const formatDateToYMDE = (
  iso?: string,
  isKor?: boolean,
  joinTxt: string = "."
) => {
  if (!iso) return "";
  const date = new Date(iso);

  return format(date, `yyyy${joinTxt}MM${joinTxt}dd(EEE)`, {
    locale: isKor ? ko : enUS,
  });
};
